import LocalStorageService from 'web-app/services/local-storage';

import * as Constants from './constants';

export const getMeetingControlsHeight = (isMobileLandscapeAndLarger?: boolean) =>
    isMobileLandscapeAndLarger ? 0 : Constants.getMeetingControlsTotalHeightMobile();

export const setUserHasCreatedAFamlyLiveMeeting = () => {
    LocalStorageService.saveForUser(Constants.LOCAL_STORAGE_KEYS.USER_HAS_CREATED_A_FAMLY_LIVE_MEETING, true);
};

export const hasUserCreatedAFamlyLiveMeeting = () => {
    return Boolean(LocalStorageService.getForUser(Constants.LOCAL_STORAGE_KEYS.USER_HAS_CREATED_A_FAMLY_LIVE_MEETING));
};

/*
 * A function to filter out duplicate objects from an array based on a key
 */
export function removeDuplicatesFromObjectArrayByKey<T extends object>(objectArray: T[], key: keyof T) {
    return objectArray.filter((obj, pos, objectArray) => {
        return objectArray.map(mapObj => mapObj[key]).indexOf(obj[key]) === pos;
    });
}
